import { FaceDetectionModalMode } from './face-detection-modal.enum';

/**
 * 顔認証モーダル動作モードマップ
 */
export const FaceDetectionModalModeMap = [
  { code: FaceDetectionModalMode.Regist, name: '新規登録' },
  { code: FaceDetectionModalMode.Auth, name: '認証' },
];



// WEBPACK FOOTER //
// ./src/app/feature/face-detection-modal/face-detection-modal.const.ts